import { render, staticRenderFns } from "./underConstruction.vue?vue&type=template&id=98145130"
import script from "./underConstruction.vue?vue&type=script&lang=js"
export * from "./underConstruction.vue?vue&type=script&lang=js"
import style0 from "./underConstruction.vue?vue&type=style&index=0&id=98145130&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports